<div class="h-screen flex flex-column">
  <div class="flex justify-content-center p-5">
    <img
      class="logo-image"
      src="/images/header_logo.svg"
      alt="Full Scale Solutions"
    />
  </div>

  <div class="flex-1 flex align-items-start md:align-items-center justify-content-center p-5">
    <div class="flex flex-column align-items-center form-width">
      @if (!isSuccess()) {
        <div class="icon-badge">
          <app-lock-03 stroke="#181D27" width="1.5rem" height="1.5rem"></app-lock-03>
        </div>
        <div class="mt-3 display-sm-semibold text-gray-900 text-center">Postavite novu lozinku</div>
        <div class="mt-2 text-md-regular text-gray-700 text-center">
          Nova lozinka mora biti drugačija od prethodno korišćenih lozinki.
        </div>

        <app-field label="Nova lozinka" for="password-input" class="mt-5 w-full">
          <app-text-input
            [hasIcon]="true"
            formCtrlType="password"
            ctrlPlaceholder="Unesite lozinku"
            [formCtrl]="form.controls['password'] | formControl"
          >
            <app-lock-03 stroke="#ADB0B8"></app-lock-03>
          </app-text-input>
        </app-field>
        <app-password-requirements class="block mt-2 w-full" [password]="passwordValue()"></app-password-requirements>

        <app-field label="Potvrdite novu lozinku" for="confirm-password-input" class="mt-3 w-full">
          <app-text-input
            [hasIcon]="true"
            formCtrlType="password"
            ctrlPlaceholder="Ponovo unesite lozinku"
            [formCtrl]="form.controls['confirmPassword'] | formControl"
          >
            <app-lock-03 stroke="#ADB0B8"></app-lock-03>
          </app-text-input>
        </app-field>


        <app-button class="mt-4 w-full" (btnClicked)="submit()" [btnSize]="ButtonSize.MD">
          <div class="text-sm-semibold text-white">Resetujte lozinku</div>
        </app-button>

        <div class="mt-4 flex align-items-center justify-content-center text-sm-semibold text-gray-700 cursor-pointer"
             (click)="goToLogin()">
          Nazad na prijavu
        </div>
      } @else {
        <div class="icon-badge success">
          <app-check-circle stroke="#067647" width="1.5rem" height="1.5rem"></app-check-circle>
        </div>
        <div class="mt-3 display-sm-semibold text-gray-900 text-center">Lozinka je uspešno promenjena</div>
        <div class="mt-2 text-md-regular text-gray-700 text-center">
          Sada se možete prijaviti koristeći novu lozinku.
        </div>

        <app-button class="mt-4 w-full" (btnClicked)="goToLogin()" [btnSize]="ButtonSize.MD">
          <div class="text-sm-semibold text-white">Idi na prijavu</div>
        </app-button>
      }
    </div>
  </div>

  <div class="flex justify-content-center text-sm-regular text-gray-600 p-5">
    © Full Scale Solutions {{ currentYear }}
  </div>
</div>
